module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add-contact":"Add Contact","add-dispatch":"Add Dispatch"},"es":{"add-contact":"Agregar contacto","add-dispatch":"Agregar Despacho"},"fr":{"add-contact":"Ajouter un contact","add-dispatch":"Ajouter un Envoi"},"sw":{"add-contact":"Ongeza Mawasiliano","add-dispatch":"Ongeza Kutuma"}}')
  delete Component.options._Ctor
}
